import React, { useState, useMemo } from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const CurrencyTabs = ({
  className,
  style,
  onChange,
  activeID,
  theme,
  tabs = [],
  ...props
}) => {
  const [activeTab, setActiveTab] = useState(activeID);
  const width = useMemo(() => {
    const diff = tabs.length > 0 ? tabs.length - 1 : 0;
    return `calc((100% - (${diff} * 4px)) / ${tabs.length})`;
  }, [tabs]);
  const left = useMemo(() => {
    const activeIdx = tabs.findIndex((item) => item.id === activeTab);
    if (activeIdx === 0) {
      return "4px";
    }
    return `calc(${width} * ${activeIdx} + ${activeIdx - 1} * 4px)`;
  }, [width, tabs, activeTab]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, className, {
        [styles[theme || ""]]: !!theme
      }),
      style: {
        ...style,
        "--left": left,
        "--width": width
      }
    },
    tabs.map((item) => /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick: () => {
          setActiveTab(item.id);
          onChange(item.id);
        },
        key: item.id,
        className: cx(styles.button, {
          [styles.active]: activeTab === item.id,
          [styles[theme || ""]]: !!theme
        }),
        style: {
          "--width": width
        }
      },
      item.name
    ))
  );
};
CurrencyTabs.displayName = "CurrencyTabs";

export { CurrencyTabs };
//# sourceMappingURL=index.js.map
